import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ActivatedRoute,Router } from '@angular/router';
import { WalletyRequestService } from '../services/wallety-request.service';
import { environment } from '../../environments/environment';
import { finalize } from 'rxjs/operators';
@Component({
  standalone:true,
  imports:[
    CommonModule,
    FormsModule,
    RouterLink,
    RouterLinkActive
  ],

  template:
  `
  <div class="contacts-card">
        <div class="spinner-container" *ngIf="isLoadingPageContent">
            <span class="spinner"></span>
        </div>
        <div *ngIf="showPageContent">
            <div *ngIf="showRequestSummary">
                <div class="grey-label">
                    Walletyme Request
                </div>
                <div class="transactionSummary-card">
                    <div class="detail-row" *ngIf="beneficiarySummary">
                        <div class="label">From</div>
                        <div class="colon"></div>
                        <div class="value">{{beneficiarySummary}}</div>
                    </div>
                    <div class="detail-row" *ngIf="requestTypeSummary">
                        <div class="label">Request Type</div>
                        <div class="colon"></div>
                        <div class="value">{{requestTypeSummary}}</div>
                    </div>
                    <div class="detail-row" *ngIf="productSummary">
                        <div class="label">Product</div>
                        <div class="colon"></div>
                        <div class="value">{{productSummary}}</div>
                    </div>
                    <div class="detail-row" *ngIf="requestAmountSummary">
                        <div class="label">Amount</div>
                        <div class="colon"></div>
                        <div class="value">{{requestAmountSummary}}</div>
                    </div>
                </div>
                <div class="authorize-btns">
                    <button class="authorize-btn"
                        (click)="MakePayment()">Make Payment
                    </button>
                </div>
            </div>

            <div *ngIf="showPaymentMethods">
            <div class="back-btn" (click)="return('requestSummary')">
                ←
                </div>
                <div class="walletyme-title">
                    Select payment method
                </div>
                <div class="category-option" *ngFor="let p of paymentMethods"
                    [class.selected]="selectedPaymentMethod === p"
                    (click)="selectPaymentMethod(p)">
                    <div class="payment-option-left">
                        <span>{{ p.name }}</span>
                    </div>
                    <img [src]="'assets/images/' + p.logo" class="payment-option-logo">
                </div>
            </div>

            <div *ngIf="showTransactionSummary">
                <div class="back-btn" (click)="return('paymentMethods')">
                ←
                </div>
                <div *ngIf="showVoucherInput">
                    <div class="voucherPin-label">
                        1Voucher Pin
                    </div>
                    <input
                        class="voucherPin-input"
                        type="text"
                        inputmode="numeric"
                        maxlength="16"
                        placeholder="Enter voucher pin"
                        [(ngModel)]="voucherPin"
                        (keydown)="allowOnlyNumbers($event)"
                        (ngModelChange)="onVoucherInput($event)">
                    <div class="validation-message" *ngIf="voucherPinValidationMessage">
                        {{voucherPinValidationMessage}}
                    </div>
                </div>
                <div class="grey-label">
                    Transaction Details
                </div>
                <div class="transactionSummary-card">
                    <div class="detail-row" *ngIf="requestTypeSummary">
                        <div class="label">Request Type</div>
                        <div class="colon"></div>
                        <div class="value">{{requestTypeSummary}}</div>
                    </div>
                    <div class="detail-row" *ngIf="beneficiarySummary">
                        <div class="label">Beneficiary</div>
                        <div class="colon"></div>
                        <div class="value">{{beneficiarySummary}}</div>
                    </div>
                    <div class="detail-row" *ngIf="productSummary">
                        <div class="label">Product</div>
                        <div class="colon"></div>
                        <div class="value">{{productSummary}}</div>
                    </div>
                    <div class="detail-row" *ngIf="paymentMethodSummary">
                        <div class="label">Payment Method</div>
                        <div class="colon"></div>
                        <div class="value">{{paymentMethodSummary}}</div>
                    </div>
                    <div class="detail-row" *ngIf="amountSummary">
                        <div class="label">Amount</div>
                        <div class="colon"></div>
                        <div class="value">{{amountSummary}}</div>
                    </div>
                    <div class="detail-row" *ngIf="serviceFeeSummary">
                        <div class="label">Service Fee</div>
                        <div class="colon"></div>
                        <div class="value">{{serviceFeeSummary}}</div>
                    </div>
                    <div class="detail-row" *ngIf="totalAmountToPaySummary">
                        <div class="totalAmountToPay-card" >
                            <div class="payment-option-left">
                            <span>{{ totalAmountToPayDescription }}</span>
                            </div>
                            <div class="colon"></div>
                            <span
                            class="totalAmount-span"
                            [ngClass]="{
                                'amount-valid': amountValid,
                                'amount-invalid': !amountValid
                            }">
                            {{ totalAmountToPaySummary }}
                            </span>
                        </div>
                    </div>
                </div>
                <!-- BUTTONS -->
                <div class="authorize-btns" *ngIf="showPayButton">
                    <button class="authorize-btn"
                        (click)="Pay()"
                         [disabled]="isLoading || (selectedPaymentMethod && selectedPaymentMethod.name !== 'Voucher' && amount>totalAmountToPay) || 
                                     (selectedPaymentMethod && selectedPaymentMethod.name === 'Voucher' && (voucherPin.length < 16 || voucherPin.length > 16 ))">
                        <span *ngIf="!isLoading">Proceed</span>
                         <span *ngIf="isLoading" class="spinner"></span>
                    </button>
                </div>
            </div>
    
            <!-- AUTHORIZE POPUP -->
            <div class="overlay" *ngIf="showAuthorizePopup">
                <div class="alert-modal">
                    <div class="section-title">
                        Authorize Transaction
                    </div>
                    <p class="pin-text">
                        Enter your 4-digit PIN.
                    </p>
                    <div class="pin-warning-text"  *ngIf="authorizationPinValidationMessage">
                        {{authorizationPinValidationMessage}}
                    </div>
                    <div class="pin-wrapper">
                        <input
                            #pinInput
                            class="hidden-pin-input"
                            type="password"
                            inputmode="numeric"
                            maxlength="4"
                            autocomplete="one-time-code"
                            [(ngModel)]="authorizationPin"
                            (keydown)="allowOnlyNumbers($event)"
                            (ngModelChange)="onPinChange($event)">

                        <div class="pin-wrapper">
                            <!-- Hidden input -->
                            <input
                                #pinInput
                                class="hidden-pin-input"
                                type="password"
                                inputmode="numeric"
                                maxlength="4"
                                autocomplete="one-time-code"
                                [(ngModel)]="authorizationPin"
                                (keydown)="allowOnlyNumbers($event)"
                                (ngModelChange)="onPinChange($event)">

                            <!-- Click anywhere to focus -->
                            <div class="pin-display" (click)="pinInput.focus()">
                                <div class="pin-circle"
                                    [class.filled]="authorizationPin.length > 0"
                                    [class.active]="authorizationPin.length === 0">
                                    {{ authorizationPin.length > 0 ? '•' : '' }}
                                </div>
                                <div class="pin-circle"
                                    [class.filled]="authorizationPin.length > 1"
                                    [class.active]="authorizationPin.length === 1">
                                    {{ authorizationPin.length > 1 ? '•' : '' }}
                                </div>
                                <div class="pin-circle"
                                    [class.filled]="authorizationPin.length > 2"
                                    [class.active]="authorizationPin.length === 2">
                                    {{ authorizationPin.length > 2 ? '•' : '' }}
                                </div>
                                <div class="pin-circle"
                                    [class.filled]="authorizationPin.length > 3"
                                    [class.active]="authorizationPin.length === 3">
                                    {{ authorizationPin.length > 3 ? '•' : '' }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="btns" *ngIf="!isLoading">
                        <button
                            class="cancel"
                            (click)="closeAuthorizePopup()">
                            Cancel
                        </button>
                        <button
                            class="primary"
                            [disabled]="authorizationPin.length !== 4"
                            (click)="confirmAuthorization()">
                            Authorize
                        </button>
                        </div>
                        <div class="spinner-container" *ngIf="isLoading">
                        <span class="spinner"></span>
                    </div>
                </div>
            </div>
            <!-- INSUFFICIENT FUNDS POPUP -->
            <div class="overlay" *ngIf="showInsufficientFundsPopup">
                <div class="alert-modal">
                    <div class="balance">
                        <div style="font-size:1rem;color:#aaa">Platform Credit</div>
                        <h1>R{{walletBalance}}</h1>
                        <div class="warning-text">
                            Insufficient funds to cover amount {{totalAmountToPaySummary}}
                        </div>
                    </div>
                    <div class="btns">
                        <button class="primary"
                                (click)="closeInsufficientFundsPopup()">
                        Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="overlay" *ngIf="showErrorPopup">
      <div class="alert-modal">
        <p class="pin-text">
            {{ errorMessage }}
        </p>
        <div class="btns">
          <button
            class="primary"
            (click)="closeErrorPopup()">
            Ok
          </button>
        </div>
      </div>
    </div>
  `
})
export class WalletyMePaymentPage{
    beneficiarySummary = '';
    requestTypeSummary = '';
    productSummary = '';
    requestAmountSummary = '';
    amount = 0;
    walletBalance = 0;
    amountValid = true;

    requestId = '';
    whatsAppUrl = environment.whatsapp_url;
    isLoading = false;
    isLoadingPageContent = true;
    showPageContent = false;
    showErrorPopup = false;
    errorMessage = '';
    paymentMethods: any[] = [];

    showRequestSummary = true;
    showTransactionSummary = false;
    showPaymentMethods = false;
    totalAmountToPaySummary = '';
    serviceFeeSummary = '';
    amountSummary = '';
    paymentMethodSummary = '';

    totalAmountToPayDescription = '';
    totalAmountToPay: number | null = null;
    serviceFee: number | null = null;
    selectedPaymentMethod:any = null;
    showPayButton = true ;
    authorizationPin = '';
    showAuthorizePopup = false;
    showInsufficientFundsPopup = false;
    voucherPin = ''
    showVoucherInput = false;
    voucherPinValidationMessage = '';
    authorizationPinValidationMessage = '';

  constructor(private route: ActivatedRoute, private router: Router, private walletyRequestService: WalletyRequestService) {}

    ngOnInit() {
        this.requestId = this.route.snapshot.paramMap.get('requestId') ?? '';
        if (!this.requestId) {
            this.errorMessage = 'Invalid links';
            this.showErrorPopup = true;
            this.isLoadingPageContent = false;
            return;
        }
        this.getRequestData();
      }
    getRequestData() {
        this.walletyRequestService
        .getWalletyMeData(this.requestId)
        .subscribe({
            next: response => {
                console.log(response);
                this.beneficiarySummary = response.beneficiary;
                this.requestTypeSummary =  response.requestType;
                this.productSummary = response.product;
                this.requestAmountSummary = response.displayAmount;
                this.amount = response.amount;
                this.paymentMethods = response.paymentMethods.$values;
                this.isLoadingPageContent = false;
                this.showPageContent = true;
            },
            error: err => {
                this.errorMessage = err.error?.message ?? 'Unable to load page.';
                this.showErrorPopup = true;
                this.isLoadingPageContent = false;
            }
            },
        );
    }
    closeErrorPopup(): void {
        this.showErrorPopup = false;
    }
    selectPaymentMethod(paymentMethod:any){
        this.selectedPaymentMethod = paymentMethod;
        this.paymentMethodSummary = paymentMethod.name;
        this.totalAmountToPay = this.amount;
         this.serviceFeeSummary = `R${this.selectedPaymentMethod.serviceFeeValue}`;
        this.totalAmountToPayDescription = 'Total Amount';
         this.amountSummary = `R${this.amount}`;

        if(this.selectedPaymentMethod.hasServiceFee){

           if(this.selectedPaymentMethod.isFixedFeeType){
                this.serviceFee = this.selectedPaymentMethod.serviceFeeValue;
                this.totalAmountToPay = Number(this.amount) + Number(this.serviceFee);

                if(this.selectedPaymentMethod.name === 'Voucher'){
                this.totalAmountToPayDescription = 'Total Deposit Amount';
                this.totalAmountToPay = Number(this.amount) - Number(this.serviceFee);
                }
            }
            else{
                this.serviceFee = (Number(this.selectedPaymentMethod.serviceFeeValue) /100)*  Number(this.amount);
                this.totalAmountToPay = Number(this.amount) + Number(this.serviceFee);

                 if(this.selectedPaymentMethod.name === 'Voucher'){
                    this.totalAmountToPayDescription = 'Total Deposit Amount';
                    this.totalAmountToPay = Number(this.amount) - Number(this.serviceFee);
                }

                 this.serviceFeeSummary = `R${this.serviceFee.toFixed(2)}`;
            }
        }
     
        this.totalAmountToPaySummary = `R${this.totalAmountToPay.toFixed(2)}`;
        this.showPaymentMethods = false;
        this.showTransactionSummary = true;

        this.voucherPin = ''; 
        if(paymentMethod.name === 'Voucher'){
            this.showVoucherInput = true;
        }
        else{
            this.showVoucherInput = false;
        }
    }
    return(view: string){
        this.selectedPaymentMethod = null;
        this.serviceFee = 0;
        this.totalAmountToPay = 0;
        
         if(view === 'paymentMethods'){
            this.showTransactionSummary = false;
            this.showPaymentMethods = true;
        }
        else if(view === 'requestSummary'){
            this.showPaymentMethods = false;
            this.showRequestSummary = true;
        }
    }
    MakePayment() {
        this.showRequestSummary = false;
        this.showPaymentMethods = true;
    }
    closeAuthorizePopup() {
        this.showPayButton = true;
        this.showAuthorizePopup = false;
        this.authorizationPin = '';
    }
    closeInsufficientFundsPopup() {
        this.showPayButton = true;
        this.showInsufficientFundsPopup = false;
    }
    //
    confirmAuthorization() {
        this.showPayButton = false;
        this.isLoading = true;
        this.walletyRequestService
        .postPay(this.requestId,
                    this.selectedPaymentMethod.id,
                    this.authorizationPin, 
                    '', 
                    0, 
                    this.totalAmountToPay)
        .pipe(
                finalize(() => this.isLoading = false)
            )
        .subscribe({
            next: response => {
                this.authorizationPin = '';
                window.location.href = response.paymentURL;
            },
            error: err => {
                this.authorizationPin = '';
                if (err.status === 406) {
                    this.showAuthorizePopup = false;
                    this.showInsufficientFundsPopup = true;
                    this.walletBalance = err.error.walletBalance;
                    return;
                }
                if (err.status === 501) {
                    this.authorizationPinValidationMessage = err.error?.message;
                    return;
                }
                if (err.status === 403) {
                    window.location.href = this.whatsAppUrl;
                    return;
                }
                this.errorMessage = err.error?.message ?? 'Unable to load page.';
                this.showErrorPopup = true;
            }
        },);
    }
    Pay(){
        if(this.paymentMethodSummary == 'Wallet'){
            this.showPayButton = false;
            this.authorizationPin = '';
            this.showAuthorizePopup = true;
        }
        else{
            this.isLoading = true;
            this.walletyRequestService
            .postPay(this.requestId,
                        this.selectedPaymentMethod.id,
                        '', 
                        this.voucherPin ?? '', 
                        this.serviceFee, 
                        this.totalAmountToPay)
            .pipe(
                    finalize(() => this.isLoading = false)
                )
            .subscribe({
                next: response => {
                    window.location.href = response.paymentURL;
                },
                error: err => {
                    if (err.status === 501) {
                        this.voucherPinValidationMessage = err.error?.message;
                        return
                    }
                    this.errorMessage = err.error?.message ?? 'Unable to load page.';
                    this.showErrorPopup = true;
                }
            },);
        }
    }
    allowOnlyNumbers(event: KeyboardEvent) {
        const allowedKeys = [
        'Backspace',
        'Delete',
        'Tab',
        'Enter',
        'ArrowLeft',
        'ArrowRight',
        'Home',
        'End'
        ];

        // Allow control keys
        if (allowedKeys.includes(event.key)) {
        return;
        }

        // Block everything except digits
        if (!/^[0-9]$/.test(event.key)) {
        event.preventDefault();
        }
    }
    onPinChange(value: string): void {
        this.authorizationPin = value.replace(/\D/g, '').slice(0, 4);
    }
}